import { Dot, Spinner, TONE_PILL } from '@/components/badges';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { statusView } from './clientLifecycleModel';

/** Active / Suspended / Deleting / Deletion failed: a tinted pill with a dot (a spinner while deleting) and the word. */
export function ClientStatusBadge({ status, testId, className }: { status: string; testId?: string; className?: string }) {
  const view = statusView(status);
  return (
    <Badge variant="outline" data-testid={testId} data-status={status} className={cn('gap-1.5 font-mono text-[11px] font-normal leading-4', TONE_PILL[view.tone], className)}>
      {view.busy ? <Spinner /> : <Dot tone={view.tone} />}
      {view.label}
    </Badge>
  );
}
